import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getList } from 'src/reducers/common/listReducer';
import InvitationRow from '../components/InvitationRow';
import EmailForm from './EmailForm';
import { withTranslation } from 'react-i18next';

class InvitationTable extends Component {
  disabledMessage(employee) {
    const { t } = this.props;
    if (!employee.email) {
      return t('features.EmployeeInvitations.components.InvitationTable.Please_input_email_address');
    } else if (employee.invitationStatus === 'registered') {
      return t('features.EmployeeInvitations.components.InvitationTable.Already_registered');
    } else if (_.isEmpty(employee.joinedOn)) {
      return t('features.EmployeeInvitations.components.InvitationTable.Please_input_hire_date');
    }
    return null;
  }

  state = {
    emailForm: {
      isOpen: false,
      employee: null
    }
  };

  render() {
    const { employees, handleSelectClick, handleSelectAllClick, selectedEmployees, isSelectAll, t } = this.props;

    return (
      <div className="l-overflow-scroll">
        <table className="m-table-list">
          <thead>
            <tr>
              <th
                onClick={() => handleSelectAllClick(employees)}
                className={isSelectAll ? 'm-table-checkbox-on' : 'm-table-checkbox-off'}
              >
                <input type="checkbox" readOnly checked={isSelectAll} />
              </th>
              <th>{t('features.EmployeeBonus.components.EmployeeBonusTable.note')}</th>
              <th>{t('features.EmployeeBonus.components.EmployeeBonusTable.staff_code')}</th>
              <th>{t('features.EmployeeBonus.components.EmployeeBonusTable.name')}</th>
              <th>{t('features.Employees.components.BasicInfoSection.email')}</th>
              <th>{t('features.EmployeeInvitations.components.InvitationTable.Invitation_Status')}</th>
              <th>{t('features.Employees.components.BusinessInfoSection.group')}</th>
              <th>{t('features.EmployeeInvitations.components.InvitationTable.Hire_date')}</th>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(employees) &&
              employees.map(employee => (
                <InvitationRow
                  key={employee.id}
                  checkboxOnClick={() => handleSelectClick(employee)}
                  employee={employee}
                  selected={!!selectedEmployees.find(item => item.id === employee.id)}
                  disabledMessage={this.disabledMessage(employee)}
                  openEmailForm={() => {
                    this.setState({ emailForm: { isOpen: true, employee } });
                  }}
                />
              ))}
            {_.isEmpty(employees) && (
              <tr>
                <td colSpan={8}>{t('features.EmployeeBonus.components.EmployeeBonusTable.no_data')}</td>
              </tr>
            )}
          </tbody>
        </table>
        <EmailForm
          {...this.state.emailForm}
          hideModal={() => {
            this.setState({ emailForm: { isOpen: false, employee: null } });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  employees: getList(REDUCER_NAME, state)
});

export default withTranslation()(connect(mapStateToProps)(InvitationTable));
